<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.6603 2.34189C10.5407 -0.777701 5.46315 -0.777701 2.34355 2.34189C0.832414 3.85363 0 5.86311 0 8.00026C0 10.1374 0.832414 12.1469 2.34355 13.658C3.90366 15.2181 5.95281 15.9979 8.00192 15.9979C10.051 15.9979 12.1002 15.2181 13.6603 13.658C16.7799 10.5384 16.7799 5.46208 13.6603 2.34189ZM12.7839 12.7816C10.1471 15.4183 5.85671 15.4183 3.21997 12.7816C1.94314 11.5048 1.23964 9.80643 1.23964 8.00026C1.23964 6.19409 1.94314 4.49576 3.21997 3.21831C5.85671 0.581562 10.1471 0.582187 12.7839 3.21831C15.42 5.85505 15.42 10.1455 12.7839 12.7816Z"
        fill="currentColor"/>
    <path d="M10.6731 9.71338L8.9184 7.96114L10.6731 6.20891C10.9149 5.96719 10.9149 5.57484 10.6738 5.33246C10.4314 5.08949 10.0391 5.09012 9.79672 5.33184L8.04077 7.08532L6.28482 5.33184C6.04247 5.09012 5.65012 5.08949 5.40778 5.33246C5.16605 5.57481 5.16605 5.96716 5.4084 6.20891L7.16314 7.96114L5.4084 9.71338C5.16605 9.9551 5.16605 10.3474 5.40778 10.5898C5.52865 10.7113 5.68793 10.7714 5.84662 10.7714C6.00531 10.7714 6.16397 10.7107 6.28485 10.5904L8.0408 8.83693L9.79676 10.5904C9.91763 10.7113 10.0763 10.7714 10.235 10.7714C10.3937 10.7714 10.553 10.7107 10.6738 10.5898C10.9155 10.3474 10.9155 9.9551 10.6731 9.71338Z"
        fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconCrossCircle"
}
</script>

<style scoped>

</style>